import AdminResellersModule from '@/modules/admin-resellers/AdminResellersModule';

export default AdminResellersModule;
